import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import LoadingOverlay from 'react-loading-overlay';
import Container from '@material-ui/core/Container';
import {login} from '../../stores/authen/actions';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import {Grid, TextField, Button, Link} from '@material-ui/core';
import {validateInputEmpty, isValidEmail} from '../../utils/common';
import SelectMultiLang from '../../components/SelectMultiLang/index';

/**
 * Login view
 */
class Index extends Component {
  /**
   * Constructor
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errorField: {
        emailMsg: false,
        passwordMsg: false,
        emailFormat: false,
      },
    };
    this.handleClickLogin = this.handleClickLogin.bind(this);
  }

  /**
   * validate field
   * @return {boolean}
   */
  validateField = () => {
    let flgErr = false;
    const errorField = {
      emailMsg: false,
      passwordMsg: false,
      emailFormat: false,
    };
    if (validateInputEmpty(this.state.email)) {
      flgErr = true;
      errorField.emailMsg = true;
    }
    if (!isValidEmail(this.state.email)) {
      flgErr = true;
      errorField.emailFormat = true;
    }
    if (validateInputEmpty(this.state.password)) {
      flgErr = true;
      errorField.passwordMsg = true;
    }
    this.setState({...this.state, errorField: errorField});
    return flgErr;
  };

  /**
   * handleClickLogin
   * @param {e} e
   */
  handleClickLogin = (e) => {
    e.preventDefault();
    const {email, password} = this.state;
    if (!this.validateField()) {
      this.props.login(email, password, this.props);
    }
  };

  /**
   * Render view
   * @return {object}
   */
  render() {
    const {authen, t} = this.props;

    return (
      <div>
        <LoadingOverlay active={authen.isLoading} bgColor="#f1f1f1" spinnerColor="#9ee5f8" textColor="#676767" spinner>
          <Container maxWidth="md" style={{height: '100vh'}}>
            <form onSubmit={this.handleClickLogin}>
              <Grid container spacing={2}>
                <Grid item xs={11} justify="center" alignItems="center" container>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={1} justify="flex-end" alignItems="center" container>
                  <SelectMultiLang />
                </Grid>
                <Grid item xs={12} justify="center" alignItems="center" container>
                  <img src={`${process.env.PUBLIC_URL}/logo-title.png`} alt="Logo" className="logo_header"></img>
                </Grid>
                <Grid item xs={12} justify="center" alignItems="center" container>
                  <br></br>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12} justify="center" alignItems="center" container>
                  <TextField
                    className="field_size_50"
                    label={t('login.email')}
                    name="email"
                    margin="dense"
                    variant="outlined"
                    value={this.state.email}
                    error={this.state.errorField.emailMsg || this.state.errorField.emailFormat}
                    helperText={
                      this.state.errorField.emailMsg ?
                        t('errorFields.emailRequired') :
                        this.state.errorField.emailFormat ?
                        t('errorFields.emailFormat') :
                        ''
                    }
                    onChange={(email) => this.setState({email: email.target.value})}
                    inputProps={{maxLength: 256}}
                  />
                </Grid>

                <Grid item xs={12} justify="center" alignItems="center" container>
                  <TextField
                    className="field_size_50"
                    label={t('login.password')}
                    name="password"
                    margin="dense"
                    variant="outlined"
                    type="password"
                    value={this.state.password}
                    error={this.state.errorField.passwordMsg}
                    helperText={this.state.errorField.passwordMsg ? t('errorFields.passwordRequired') : ''}
                    onChange={(password) => this.setState({password: password.target.value})}
                    inputProps={{maxLength: 256}}
                  />
                </Grid>
              </Grid>
              <br></br>
              <br></br>
              <Grid container spacing={6}>
                <Grid item xs={12} justify="center" alignItems="center" container>
                  <Link href="/maas/password-reissue">{t('login.passwordReissue')}</Link>
                </Grid>

                <Grid item container justify="center" alignItems="center" xs={12}>
                  <Button type="submit" variant="contained" color="primary" endIcon={<LockOpenOutlinedIcon />}>
                    {t('common.btnLogin')}
                  </Button>
                </Grid>
              </Grid>
            </form>
            <br></br>
          </Container>
        </LoadingOverlay>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authen: state.authen,
    modal: state.modal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (email, password, props) => dispatch(login(email, password, props)),
  };
};

export default withTranslation('translations')(connect(mapStateToProps, mapDispatchToProps)(Index));
